const APPLICATION_SHOWS = [
  {
    key: 'diamond-jewellery',
    preferredIds: ['diamond-jewellery-september'],
    brand: 'CARATJEWEL EXPO',
    name: 'Diamond Jewellery Show',
    category: 'Diamond Jewellery',
    status: 'Upcoming Show',
    schedule: 'Schedule Announcing Soon',
    description: 'A focused online exhibition for discovering and presenting diamond jewellery collections in a professional business setting.',
    exhibitors: 'For manufacturers and suppliers of diamond jewellery.'
  }
];

const isDiamondJewellery = (show) => /diamond jewellery/i.test(`${show?.name || ''} ${show?.short || ''} ${show?.category || ''}`);

export function exhibitorApplicationShows(exhibitions = []) {
  return APPLICATION_SHOWS.map((profile) => {
    const record = exhibitions.find((show) => profile.preferredIds.includes(show.id))
      || exhibitions.find((show) => show.status === 'Upcoming' && isDiamondJewellery(show))
      || exhibitions.find(isDiamondJewellery);
    return record ? {...profile, id: record.id} : null;
  }).filter(Boolean);
}

export function exhibitorApplicationShowLabel(showId, exhibitions = []) {
  if (!showId) return 'No exhibition specified';
  const configured = exhibitorApplicationShows(exhibitions).find((show) => show.id === showId);
  if (configured) return `${configured.brand} - ${configured.name}`;
  return exhibitions.find((show) => show.id === showId)?.name || showId;
}
